module.exports = __webpack_public_path__ + "static/img/m-zh.6d48b63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/m-zh.png
// module id = Djqy
// module chunks = 0